import React from 'react';
import { Section } from '@/components/shared/section/Section';

export const NotFound: React.FC = () => {
  return (
    <Section title="404 Not Found">
      <div className="flex flex-col items-center gap-1 p-10">
        <span className="text-lg font-bold">404 Not Found</span>
        <p>The page you are looking for was not found.</p>
        <p>Please go back to the previous page or contact admin if you think this is an error.</p>
      </div>
    </Section>
  );
};
